export default class Uint8ArrayUtils {
    /**
     * Convert a Uint8Array to a base64 string.
     * @param {!Uint8Array} arr
     * @returns {string}
     */
    static toBase64(arr) {
        return btoa(String.fromCharCode(...new Uint8Array(arr)));
    }

    /**
     * Convert a Uint8Array to a string.
     * @param {!Uint8Array} arr
     * @returns {string}
     */
    static toString(arr) {
        const enc = new TextDecoder();
        return enc.decode(arr);
    }

    /**
     * Convert a base64 string to a Uint8Array.
     * @param {string} str
     * @return {!Uint8Array}
     */
    static fromBase64(str) {
        // atob creates a "raw string" where each character is interpreted as a byte.
        const bytes = window.atob(str.replace(/-/g, '+').replace(/_/g, '/'));
        const result = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i += 1) {
            result[i] = bytes.charCodeAt(i);
        }
        return result;
    }
}